import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';
import { InteractionLogEntry } from '../../../../types/interaction-log-data';

export function detectRepeatedMessagePlayback(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  const messageLogs = logs.filter(
    (log) =>
      log.LogData.Action?.Type === 'MessageParticipant' || log.LogData.Action?.Type === 'MessageParticipantIteratively'
  );

  // Group by message content to find repeated messages
  const messageGroups = new Map<string, InteractionLogEntry[]>();
  messageLogs.forEach((log) => {
    const textParam = log.LogData.Action?.Parameters?.Text;
    const content = typeof textParam === 'string' ? textParam : '';
    if (!messageGroups.has(content)) {
      messageGroups.set(content, []);
    }
    messageGroups.get(content)?.push(log);
  });

  messageGroups.forEach((groupedLogs, message) => {
    if (groupedLogs.length >= 4) {
      const originalIndex = logs.indexOf(groupedLogs[0]);
      problems.push({
        id: generateId(),
        type: ProblemType.REPEATED_MESSAGE_PLAYBACK,
        severity: groupedLogs.length >= 6 ? ProblemSeverity.MEDIUM : ProblemSeverity.LOW,
        title: 'Repeated Message Playback',
        description: `Same message played ${groupedLogs.length} times: ${
          message === '' ? '<unavailable>' : message.substring(0, 50) + '...'
        }`,
        timestamp: groupedLogs[0].AbsoluteTime,
        source: 'IVR_LOG',
        relatedData: { repeatCount: groupedLogs.length, message, logs: groupedLogs },
        suggestions: [
          'Review flow logic to prevent message loops',
          'Consider adding escape conditions',
          'Improve input validation and error handling'
        ],
        index: originalIndex >= 0 ? originalIndex : undefined
      });
    }
  });

  return problems;
}
